import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

export const kNavHeaderGradient = ['#009FD4', '#2669db'] as const;

/**
 * The single colour the nav header reads as: the midpoint of its gradient,
 * for accents (e.g. the active tab) that should match it.
 */
export const kNavHeaderBlue = '#1384D7';

export const NavHeaderBg = () => (
  <LinearGradient
    colors={[...kNavHeaderGradient]}
    style={StyleSheet.absoluteFill}
  />
);
